export default __webpack_public_path__ + "static/media/p7-3.349d07a9.png";